<template>
  <div class="bg-lightPrimaryColor dark:bg-darkPrimaryColor flex flex-col items-center justify-center py-12 text-center">
    <div class="bg-lightSecondaryColor dark:bg-darkSecondaryColor mb-4 flex h-16 w-16 items-center justify-center rounded-full">
      <BaseIcon :icon="Icon.SEARCH" class="text-lightSecondaryTextColor dark:text-darkSecondaryTextColor h-8 w-8" />
    </div>
    <h3 class="text-lightPrimaryTextColor dark:text-darkPrimaryTextColor mb-1 text-lg font-semibold">
      {{ $t("quickAccess.noResults") }}
    </h3>
    <p class="text-lightSecondaryTextColor dark:text-darkSecondaryTextColor text-sm">
      {{ $t("quickAccess.tryDifferentSearch") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { Icon } from "../assets/icons/Icon";
import BaseIcon from "../components/BaseIcon.vue";
</script>
